module.exports = __webpack_public_path__ + "img/20.dcb88b00.jpg";